var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterDorg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 5.89734H34.5222V7.00723H35.6094V5.89734Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 4.64357H34.5222V5.75346H35.6094V4.64357Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8391 5.89734H35.7519V7.00723H36.8391V5.89734Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8391 8.40898H35.7519V9.51888H36.8391V8.40898Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 8.40898H34.5222V9.51888H35.6094V8.40898Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8391 9.66686H35.7519V10.7768H36.8391V9.66686Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8391 10.9247H35.7519V12.0346H36.8391V10.9247Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 10.9247H34.5222V12.0346H35.6094V10.9247Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 9.66686H34.5222V10.7768H35.6094V9.66686Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8391 12.1785H35.7519V13.2884H36.8391V12.1785Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 12.1785H34.5222V13.2884H35.6094V12.1785Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8391 13.4364H35.7519V14.5463H36.8391V13.4364Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 13.4364H34.5222V14.5463H35.6094V13.4364Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 14.6902H34.5222V15.8H35.6094V14.6902Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3756 13.4364H33.2884V14.5463H34.3756V13.4364Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1418 13.4364H32.0546V14.5463H33.1418V13.4364Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3756 14.6902H33.2884V15.8H34.3756V14.6902Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1418 14.6902H32.0546V15.8H33.1418V14.6902Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.908 13.4364H30.8208V14.5463H31.908V13.4364Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.908 14.6902H30.8208V15.8H31.908V14.6902Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3756 10.9247H33.2884V12.0346H34.3756V10.9247Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3756 9.66686H33.2884V10.7768H34.3756V9.66686Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1418 10.9247H32.0546V12.0346H33.1418V10.9247Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1418 9.66686H32.0546V10.7768H33.1418V9.66686Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.908 10.9247H30.8208V12.0346H31.908V10.9247Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.908 9.66686H30.8208V10.7768H31.908V9.66686Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6742 10.9247H29.587V12.0346H30.6742V10.9247Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6742 9.66686H29.587V10.7768H30.6742V9.66686Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4444 9.66686H28.3572V10.7768H29.4444V9.66686Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6742 8.40898H29.587V9.51888H30.6742V8.40898Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4444 8.40898H28.3572V9.51888H29.4444V8.40898Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8391 7.15521H35.7519V8.26511H36.8391V7.15521Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6094 7.15521H34.5222V8.26511H35.6094V7.15521Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6742 7.15521H29.587V8.26511H30.6742V7.15521Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4444 7.15521H28.3572V8.26511H29.4444V7.15521Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4444 5.89734H28.3572V7.00723H29.4444V5.89734Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6742 5.89734H29.587V7.00723H30.6742V5.89734Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6742 4.64357H29.587V5.75346H30.6742V4.64357Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.908 5.89734H30.8208V7.00723H31.908V5.89734Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.908 4.64357H30.8208V5.75346H31.908V4.64357Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1418 5.89734H32.0546V7.00723H33.1418V5.89734Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1418 4.64357H32.0546V5.75346H33.1418V4.64357Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3756 5.89734H33.2884V7.00723H34.3756V5.89734Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3756 4.64357H33.2884V5.75346H34.3756V4.64357Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2795 7.15521H22.1923V8.26511H23.2795V7.15521Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5133 5.89734H23.4261V7.00723H24.5133V5.89734Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5133 4.64357H23.4261V5.75346H24.5133V4.64357Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M25.743 5.89734H24.6558V7.00723H25.743V5.89734Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M25.743 4.64357H24.6558V5.75346H25.743V4.64357Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9768 5.89734H25.8896V7.00723H26.9768V5.89734Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9768 4.64357H25.8896V5.75346H26.9768V4.64357Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0457 5.89734H20.9585V7.00723H22.0457V5.89734Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2795 5.89734H22.1923V7.00723H23.2795V5.89734Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0457 7.15521H20.9585V8.26511H22.0457V7.15521Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0457 8.40898H20.9585V9.51888H22.0457V8.40898Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0457 9.66686H20.9585V10.7768H22.0457V9.66686Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0457 10.9247H20.9585V12.0346H22.0457V10.9247Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8119 10.9247H19.7246V12.0346H20.8119V10.9247Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8119 9.66686H19.7246V10.7768H20.8119V9.66686Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8119 8.40898H19.7246V9.51888H20.8119V8.40898Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8119 7.15521H19.7246V8.26511H20.8119V7.15521Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8119 5.89734H19.7246V7.00723H20.8119V5.89734Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0457 4.64357H20.9585V5.75346H22.0457V4.64357Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8119 4.64357H19.7246V5.75346H20.8119V4.64357Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4172 2.05793H12.3299V3.16782H13.4172V2.05793Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4172 0.800049H12.3299V1.90994H13.4172V0.800049Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6469 0.800049H13.5597V1.90994H14.6469V0.800049Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8807 0.800049H14.7935V1.90994H15.8807V0.800049Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8807 2.05793H14.7935V3.16782H15.8807V2.05793Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6469 2.05793H13.5597V3.16782H14.6469V2.05793Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 0.800049H16.0273V1.90994H17.1145V0.800049Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3483 2.05793H17.2611V3.16782H18.3483V2.05793Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 2.05793H16.0273V3.16782H17.1145V2.05793Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 3.3117H16.0273V4.42159H17.1145V3.3117Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3483 3.3117H17.2611V4.42159H18.3483V3.3117Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3483 4.56957H17.2611V5.67947H18.3483V4.56957Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 4.56957H16.0273V5.67947H17.1145V4.56957Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 5.82334H16.0273V6.93324H17.1145V5.82334Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3483 5.82334H17.2611V6.93324H18.3483V5.82334Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3483 7.08122H17.2611V8.19111H18.3483V7.08122Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 7.08122H16.0273V8.19111H17.1145V7.08122Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 8.33499H16.0273V9.44488H17.1145V8.33499Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3483 8.33499H17.2611V9.44488H18.3483V8.33499Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3483 9.59287H17.2611V10.7028H18.3483V9.59287Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 9.59287H16.0273V10.7028H17.1145V9.59287Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1145 10.8507H16.0273V11.9606H17.1145V10.8507Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8807 10.8507H14.7935V11.9606H15.8807V10.8507Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8807 9.59287H14.7935V10.7028H15.8807V9.59287Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6469 10.8507H13.5597V11.9606H14.6469V10.8507Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6469 9.59287H13.5597V10.7028H14.6469V9.59287Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4172 10.8507H12.3299V11.9606H13.4172V10.8507Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4172 9.59287H12.3299V10.7028H13.4172V9.59287Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 10.8507H11.0961V11.9606H12.1833V10.8507Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 9.59287H11.0961V10.7028H12.1833V9.59287Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 8.33499H11.0961V9.44488H12.1833V8.33499Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 7.08122H11.0961V8.19111H12.1833V7.08122Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 5.82334H11.0961V6.93324H12.1833V5.82334Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 4.56957H11.0961V5.67947H12.1833V4.56957Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 3.3117H11.0961V4.42159H12.1833V3.3117Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 2.05793H11.0961V3.16782H12.1833V2.05793Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1833 0.800049H11.0961V1.90994H12.1833V0.800049Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 2.05793H9.86232V3.16782H10.9495V2.05793Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 3.3117H9.86232V4.42159H10.9495V3.3117Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 4.56957H9.86232V5.67947H10.9495V4.56957Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 5.82334H9.86232V6.93324H10.9495V5.82334Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 7.08122H9.86232V8.19111H10.9495V7.08122Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 8.33499H9.86232V9.44488H10.9495V8.33499Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9495 9.59287H9.86232V10.7028H10.9495V9.59287Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32103 10.8507H1.23381V11.9606H2.32103V10.8507Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55076 10.8507H2.46354V11.9606H3.55076V10.8507Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78457 10.8507H3.69735V11.9606H4.78457V10.8507Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01838 10.8507H4.93116V11.9606H6.01838V10.8507Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 10.8507H6.16497V11.9606H7.25219V10.8507Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48192 9.59287H7.3947V10.7028H8.48192V9.59287Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 9.59287H6.16497V10.7028H7.25219V9.59287Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01838 9.59287H4.93116V10.7028H6.01838V9.59287Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78457 9.59287H3.69735V10.7028H4.78457V9.59287Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55076 9.59287H2.46354V10.7028H3.55076V9.59287Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32103 9.59287H1.23381V10.7028H2.32103V9.59287Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08722 9.59287H0V10.7028H1.08722V9.59287Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08722 8.33499H0V9.44488H1.08722V8.33499Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32103 8.33499H1.23381V9.44488H2.32103V8.33499Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 8.33499H6.16497V9.44488H7.25219V8.33499Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48192 8.33499H7.3947V9.44488H8.48192V8.33499Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48192 7.08122H7.3947V8.19111H8.48192V7.08122Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 7.08122H6.16497V8.19111H7.25219V7.08122Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32103 7.08122H1.23381V8.19111H2.32103V7.08122Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08722 7.08122H0V8.19111H1.08722V7.08122Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08722 5.82334H0V6.93324H1.08722V5.82334Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32103 5.82334H1.23381V6.93324H2.32103V5.82334Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55076 5.82334H2.46354V6.93324H3.55076V5.82334Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78457 5.82334H3.69735V6.93324H4.78457V5.82334Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01838 5.82334H4.93116V6.93324H6.01838V5.82334Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 5.82334H6.16497V6.93324H7.25219V5.82334Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48192 5.82334H7.3947V6.93324H8.48192V5.82334Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48192 4.56957H7.3947V5.67947H8.48192V4.56957Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48192 3.3117H7.3947V4.42159H8.48192V3.3117Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48192 2.05793H7.3947V3.16782H8.48192V2.05793Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48192 0.800049H7.3947V1.90994H8.48192V0.800049Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 0.800049H6.16497V1.90994H7.25219V0.800049Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 2.05793H6.16497V3.16782H7.25219V2.05793Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 3.3117H6.16497V4.42159H7.25219V3.3117Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25219 4.56957H6.16497V5.67947H7.25219V4.56957Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01838 4.56957H4.93116V5.67947H6.01838V4.56957Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78457 4.56957H3.69735V5.67947H4.78457V4.56957Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55076 4.56957H2.46354V5.67947H3.55076V4.56957Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32103 4.56957H1.23381V5.67947H2.32103V4.56957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDorg);
export default __webpack_public_path__ + "static/media/footer_dorg.c2a509bb600ca223653304cec7e80c6f.svg";
export { ForwardRef as ReactComponent };